// src/components/CookiePolicy.tsx
import React from "react";
import { Box, Heading, Text, VStack, UnorderedList, ListItem, Link, Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { companyConfig } from "../config/company";

const CookiePolicy: React.FC = () => {
  const { operatorDescription, supportEmail, website, effectiveDate } = companyConfig;

  return (
    <Box maxW="860px" mx="auto" px={6} py={10}>
      <VStack align="start" spacing={6}>

        <Heading size="xl">Cookie Policy</Heading>
        <Text fontSize="sm" color="gray.500">Effective date: {effectiveDate}</Text>

        <Text>
          This Cookie Policy explains how {operatorDescription} uses cookies and similar
          technologies when you use our platform at{" "}
          <Link href={website} color="blue.500">{website}</Link>.
        </Text>

        <Heading size="md">1. What Are Cookies</Heading>
        <Text>
          Cookies are small text files stored on your device when you visit a website.
          They help the website remember information about your visit.
        </Text>

        <Heading size="md">2. Cookies We Use</Heading>
        <Box overflowX="auto">
          <Table size="sm" variant="simple" mt={2}>
            <Thead>
              <Tr>
                <Th>Cookie</Th>
                <Th>Purpose</Th>
                <Th>Type</Th>
                <Th>Duration</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td><code>b2c_token</code></Td>
                <Td>Stores your authentication token to keep you logged in</Td>
                <Td>Essential</Td>
                <Td>Session / 8 hours</Td>
              </Tr>
              <Tr>
                <Td><code>localStorage</code> keys</Td>
                <Td>Stores session preferences and temporary state</Td>
                <Td>Essential</Td>
                <Td>Session</Td>
              </Tr>
            </Tbody>
          </Table>
        </Box>

        <Heading size="md">3. Essential Cookies</Heading>
        <Text>
          We use only essential cookies necessary for the platform to function. These
          cookies do not track you across other websites and are not used for advertising.
          Because they are strictly necessary, they do not require your consent under
          Australian law, though we disclose their use here for transparency.
        </Text>

        <Heading size="md">4. Third-Party Cookies</Heading>
        <Text>
          Our payment provider Stripe may set cookies during the checkout process. These
          are governed by{" "}
          <Link href="https://stripe.com/au/privacy" color="blue.500" isExternal>
            Stripe's Privacy Policy
          </Link>
          . We use Google reCAPTCHA on login forms which may set cookies governed by
          Google's Privacy Policy.
        </Text>

        <Heading size="md">5. Managing Cookies</Heading>
        <Text>
          You can control cookies through your browser settings. Disabling essential
          cookies will prevent the platform from functioning correctly — in particular,
          you will not be able to remain logged in.
        </Text>

        <Heading size="md">6. Contact</Heading>
        <Text>
          <Link href={`mailto:${supportEmail}`} color="blue.500">{supportEmail}</Link>
        </Text>

      </VStack>
    </Box>
  );
};

export default CookiePolicy;